import request from '../utils/request'

/** Exam / RE_Arena APIs kept for DSA exam delivery */

export function postRequest(url, params) {
    return request.post(url, {
        ...params
    })
}

export function getExerciseTemplateByStudent(template_id, user_id) {
    return request.post('./index.php', {
        function: 'getExerciseTemplateByStudent',
        template_id,
        user_id
    })
}

export function changeVisibleLog(student_id, project_code, template_id) {
    return request.post('/RE_Arena/index.php', {
        function: 'changeVisibleLog',
        student_id,
        project_code,
        template_id
    })
}

export function getTestVisibleChangeCount(template_id, student_id, project_code) {
    return request.post('/RE_Arena/index.php', {
        function: 'getTestVisibleChangeCount',
        template_id,
        student_id,
        project_code
    })
}

export function submitAnswer(question_id, template_id, choice, student_id, ip, test_event, project_code, answer_img_url) {
    return request.post('./index.php', {
        function: 'submitAnswer',
        question_id,
        template_id,
        choice,
        student_id,
        ip,
        test_event,
        project_code,
        answer_img_url
    })
}

export function uploadAnswersV3(project_code, student_id, template_id, app_id, ip, test_event, test_type, answers) {
    return request.post('./index.php', {
        function: 'uploadAnswersByLogsNew',
        project_code,
        student_id,
        template_id,
        app_id,
        ip,
        test_event,
        test_type,
        answers
    })
}

export function uploadPic(param) {
    return request.post('./index.php', param)
}

export function checkIsUploadTest(template_id, student_id) {
    return request.post('./index.php', {
        function: 'checkIsUploadTest',
        template_id,
        student_id
    })
}

export function initExamShotTimePoint(student_id, project_code, template_id) {
    return request.post('/RE_Arena/index.php', {
        function: 'initExamShotTimePoint',
        student_id,
        project_code,
        template_id
    })
}

export function uploadExamShotNew(param) {
    return request.post('/RE_Arena/index.php', param)
}

export function uploadTestHeartBeat(student_id, template_id, status) {
    return request.post('/RE_Arena/index.php', {
        function: 'uploadTestHeartBeat',
        student_id,
        template_id,
        status
    })
}

export function studentSignWithTemplate(student_id, template_id, project_code) {
    return request.post('./index.php', {
        function: 'studentSignWithTemplate',
        student_id,
        template_id,
        project_code
    })
}

export function studentUpdateTemplateWithIndex(student_id, template_id, project_code, index) {
    return request.post('./index.php', {
        function: 'studentUpdateTemplateWithIndex',
        student_id,
        template_id,
        project_code,
        index
    })
}

export function uploadStudentIdCard(student_id, template_id, project_code, pic_url) {
    return request.post('./index.php', {
        function: 'uploadStudentIdCard',
        student_id,
        template_id,
        project_code,
        pic_url
    })
}

export function getStudentIdCard(student_id, template_id, project_code) {
    return request.post('./index.php', {
        function: 'getStudentIdCard',
        student_id,
        template_id,
        project_code
    })
}

export function getGroupId(id) {
    return request.post('./index.php', {
        function: 'getGroupId',
        id
    })
}

export function getQiniuToken() {
    return request.post('./index.php', {
        function: 'getQiniuToken'
    })
}

export function getMyMessages(id, project_code) {
    return request.post('./DSA/index.php', {
        function: 'getMyMessages',
        id,
        project_code
    })
}

export function sendMessage(student_id, type, sender_type, content, project_code, template_name) {
    return request.post('./DSA/index.php', {
        function: 'sendMessage',
        student_id,
        type,
        sender_type,
        content,
        project_code,
        template_name
    })
}
